import type { ButtonTypes } from "@/components/button";
import type { GroupKind } from "../_types/groups.types";

export const GROUP_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
] as const;

export const GROUP_KIND_FILTER_OPTIONS = [
  { value: "all", label: "All types" },
  { value: "device", label: "Device groups" },
  { value: "user", label: "User groups" },
  { value: "mixed", label: "Mixed" },
] as const;

export const GROUP_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export type GroupToolbarTab = (typeof GROUP_TAB_ITEMS)[number]["value"];
export type GroupKindFilter = (typeof GROUP_KIND_FILTER_OPTIONS)[number]["value"];
export type GroupPeriodFilter = (typeof GROUP_PERIOD_OPTIONS)[number]["value"];

type BadgeVariant = NonNullable<ButtonTypes["variant"]>;

const GROUP_KIND_META: Record<GroupKind, { label: string; variant: BadgeVariant }> = {
  device: { label: "Devices", variant: "primary" },
  user: { label: "Users", variant: "success" },
  mixed: { label: "Mixed", variant: "warning" },
};

export const getGroupKindMeta = (kind: GroupKind) => GROUP_KIND_META[kind];

export const formatGroupTimestamp = (timestamp: number) =>
  new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(timestamp));
